import React, { useCallback, useEffect, useMemo, useState } from 'react';
import MaterialReactTable from 'material-react-table';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    MenuItem,
    Stack,
    TextField,
    Checkbox,
    Tooltip,
    FormGroup,
    FormControlLabel,
    FormControl,
    FormLabel,
    InputLabel,
    Select,
    Avatar,
} from '@mui/material';
import { Delete, Edit, Save } from '@mui/icons-material';
import { useSelector } from 'react-redux';

import { createTheme, ThemeProvider, useTheme } from '@mui/material';
import { AccessControlAPI } from '../../API/Endpoints/Backend/AccessControl/AccessControlAPI';
import { AuthAPI } from '../../API/Endpoints/Backend/AccessControl/AuthAPI';
import { signupAdmin } from '../../API/Configs/APIUtils';
import { RolesAPI } from '../../API/Endpoints/Backend/RolesAPI';
import { TagsAPI } from '../../API/Endpoints/Backend/TagsAPI';


//example of creating a mui dialog modal for creating new rows
export const CreateNewTagModal = ({ open, columns, onClose, onSubmit }) => {

    // const [accessControls, setAccessControls] = useState([]);

    // const [roleId, setRoleId] = useState("");
    // const [email, setEmail] = useState("");
    // const [password, setPassword] = useState("");
    const [tagName, settagName] = useState("");

    const handleSubmit = () => {

        TagsAPI.addTags([tagName])
            .then(response => { console.log(response) });

        var temp = {
            tagName: tagName
        }

        onSubmit(temp);
        onClose();
    };

    useEffect(() => {
        // AccessControlAPI.findAll()
        //     .then(res => {
        //         setAccessControls(res);
        //     });
    }, [])


    return (
        <Dialog open={open}>
            <DialogTitle textAlign="center">Create New Account</DialogTitle>
            <DialogContent>
                <form onSubmit={(e) => e.preventDefault()}>
                    <Stack
                        sx={{
                            width: '100%',
                            minWidth: { xs: '300px', sm: '360px', md: '400px' },
                            gap: '1.5rem',
                        }}
                    >

                        <TextField
                            key="tagName"
                            label="tagName"
                            name="tagName"
                            value={tagName}
                            onChange={(e) =>
                                settagName(e.target.value)
                            }
                        />
                    </Stack>
                </form>
            </DialogContent>

            <DialogActions sx={{ p: '1.25rem' }}>
                <Button onClick={onClose}>Cancel</Button>
                <Button color="secondary" onClick={handleSubmit} variant="contained">
                    Create New Role
                </Button>
            </DialogActions>
        </Dialog>
    );
};
